import _slicedToArray from "/home/runner/work/design/design/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/design/design/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useCallback, useReducer, useRef } from 'react';
import { useSSRSafeId } from '@react-aria/ssr';
import { AutocompleteContext } from './AutocompleteContext';
import AutocompleteInput from './AutocompleteInput';
import AutocompleteMenu from './AutocompleteMenu';
import AutocompleteOverlay from './AutocompleteOverlay';
var initialState = {
  inputValue: '',
  showMenu: false,
  isMenuDirectlyActivated: false,
  autocompleteSuggestion: '',
  selectedItemLength: 0
};
var reducer = function reducer(state, action) {
  var type = action.type,
    payload = action.payload;
  switch (type) {
    case 'inputValue':
      return _objectSpread(_objectSpread({}, state), {}, {
        inputValue: payload
      });
    case 'showMenu':
      return _objectSpread(_objectSpread({}, state), {}, {
        showMenu: payload
      });
    case 'isMenuDirectlyActivated':
      return _objectSpread(_objectSpread({}, state), {}, {
        isMenuDirectlyActivated: payload
      });
    case 'autocompleteSuggestion':
      return _objectSpread(_objectSpread({}, state), {}, {
        autocompleteSuggestion: payload
      });
    case 'selectedItemLength':
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedItemLength: payload
      });
    default:
      return state;
  }
};
var Autocomplete = function Autocomplete(_ref) {
  var children = _ref.children,
    idProp = _ref.id;
  var activeDescendantRef = useRef(null);
  var scrollContainerRef = useRef(null);
  var inputRef = useRef(null);
  var _useReducer = useReducer(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var inputValue = state.inputValue,
    showMenu = state.showMenu,
    autocompleteSuggestion = state.autocompleteSuggestion,
    isMenuDirectlyActivated = state.isMenuDirectlyActivated,
    selectedItemLength = state.selectedItemLength;
  var setInputValue = useCallback(function (value) {
    dispatch({
      type: 'inputValue',
      payload: value
    });
  }, []);
  var setShowMenu = useCallback(function (value) {
    dispatch({
      type: 'showMenu',
      payload: value
    });
  }, []);
  var setAutocompleteSuggestion = useCallback(function (value) {
    dispatch({
      type: 'autocompleteSuggestion',
      payload: value
    });
  }, []);
  var setIsMenuDirectlyActivated = useCallback(function (value) {
    dispatch({
      type: 'isMenuDirectlyActivated',
      payload: value
    });
  }, []);
  var setSelectedItemLength = useCallback(function (value) {
    dispatch({
      type: 'selectedItemLength',
      payload: value
    });
  }, []);
  var id = useSSRSafeId(idProp);
  return /*#__PURE__*/React.createElement(AutocompleteContext.Provider, {
    value: {
      activeDescendantRef: activeDescendantRef,
      autocompleteSuggestion: autocompleteSuggestion,
      id: id,
      inputRef: inputRef,
      inputValue: inputValue,
      isMenuDirectlyActivated: isMenuDirectlyActivated,
      scrollContainerRef: scrollContainerRef,
      selectedItemLength: selectedItemLength,
      setAutocompleteSuggestion: setAutocompleteSuggestion,
      setInputValue: setInputValue,
      setIsMenuDirectlyActivated: setIsMenuDirectlyActivated,
      setShowMenu: setShowMenu,
      setSelectedItemLength: setSelectedItemLength,
      showMenu: showMenu
    }
  }, children);
};
Autocomplete.displayName = "Autocomplete";
export default Object.assign(Autocomplete, {
  Context: AutocompleteContext,
  Input: AutocompleteInput,
  Menu: AutocompleteMenu,
  Overlay: AutocompleteOverlay
});